module.exports = __webpack_public_path__ + "img/ckgdicon.3d9899e5.svg";